import React from "react";
import styles from "./Footer.module.scss";

import { ReactComponent as LogoColor } from "../../assets/logo-color.svg";
import { Link } from "../ui/Link";

export class Footer extends React.Component {
  getArchiveLink() {
    const path = window.location.pathname;

    if (path.includes("/award/faq/")) {
      return {
        href: "https://www.mlit.go.jp/plateau-next/2025/award/",
        text: "Archive：PLATEAU AWARD 2025",
      };
    } else if (path.includes("/award/")) {
      return {
        href: "https://www.mlit.go.jp/plateau-next/2025/award/",
        text: "Archive：PLATEAU AWARD 2025",
      };
    } else {
      return {
        href: "https://www.mlit.go.jp/plateau-next/2025/",
        text: "Archive：PLATEAU NEXT 2025",
      };
    }
  }
  render() {
    const archiveLink = this.getArchiveLink();

    return (
      <footer className={styles["footer"]}>
        <div className={styles["left"]}>
          <Link
            href={"/"}
            className={styles["logo"]}
            arrow={false}
            decoration={false}
          >
            <img src={"assets/logo-color.svg"} />
          </Link>
        </div>
        <div className={styles["right"]}>
          Copyright© MLIT Japan. All Rights Reserved.
          <Link decoration={false} href={archiveLink.href} target={"_blank"}>
            {archiveLink.text}
          </Link>
          <Link decoration={false} href={"https://www.mlit.go.jp/plateau/"}>
            Project PLATEAU WEB SITE
          </Link>
          <Link
            decoration={false}
            href={"https://www.mlit.go.jp/plateau/contact/"}
          >
            Project PLATEAUに関するお問い合わせ
          </Link>
        </div>
      </footer>
    );
  }
}
